import React from 'react';
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();

  return (
    <section className="about-section" id="about">
      <h3>{t('about.title')}</h3>
      <div className="about-content">
        <p className="about-intro">
          {t('about.intro').split('**').map((part, index) => 
            index % 2 === 1 ? <strong key={index}>{part}</strong> : part
          )}
        </p>
        <p className="about-description">{t('about.description')}</p>
        <div className="about-pillars">
          <h4>{t('about.pillars.title')}</h4>
          <ul className="pillars-list">
            {t('about.pillars.items', { returnObjects: true }).map((pillar, index) => (
              <li key={index}>
                <strong>{pillar.title}:</strong> {pillar.description}
              </li>
            ))}
          </ul>
        </div>
        <p className="about-clients">{t('about.clients')}</p>
      </div>
    </section>
  );
}

export default About; 